module.exports = __webpack_public_path__ + "img/fourBgIcon.b234f611.png";